// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //

function getColor({ theme }) {
  return {
    backgroundColor: theme.palette.secondary.main,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.darker,
      opacity: 0.85,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.dark,
      borderWidth: '1px',
      borderRadius: '4px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary,
      boxShadow: theme.customShadows.inputShadow,
    },
    '&:hover .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.disabled,
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.error.main}`,
      boxShadow: theme.customShadows.inputShadow,
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.text.disabled}`,
        boxShadow: theme.customShadows.inputShadow,
      },
    },
  }
}

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '8px 12px',
          height: 'auto',
          lineHeight: '1.250rem',
          color: theme.palette.text.primary,
          '&::placeholder': {
            color: theme.palette.text.disabled,
            opacity: 1,
          },
          '&.Mui-disabled': {
            color: theme.palette.text.secondary,  
            WebkitTextFillColor: theme.palette.text.secondary,
            '&::placeholder': {
              color: theme.palette.text.secondary,
            },
            '&.MuiIconButton-root': {
              color: theme.palette.text.secondary,
            },
          },
        },
        notchedOutline: {
          borderWidth: '1px',
          borderRadius: '4px',
        },
        root: {
          ...getColor({ variant: 'primary', theme }),
          '&.Mui-error': {
            ...getColor({ variant: 'error', theme }),
            opacity: 0.9,
          },
          '& .MuiSvgIcon-root': {
            fontSize: '16px',
          },
          '&.MuiInputBase-multiline': {
            padding: '8px 12px',
            '& .MuiInputAdornment-root': {
              alignSelf: 'flex-start',
              marginTop: '8px',
            },
          },
        },
        inputSizeSmall: {
          padding: '4px 12px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '2px',
            borderWidth: '0.5px',
          },
          '& .MuiSvgIcon-root': {
            fontSize: '14px',
          },
        },
        inputSizeLarge: {
          padding: '12px',
          '& .MuiSvgIcon-root': {
            fontSize: '18px',
          },
        },
        inputMultiline: {
          padding: 0,
        },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme }),
      },
    },
  }
}
